/**
 * querySelector wrapper
 *
 * @param {string} selector Selector to query
 * @param {Element} [scope] Optional scope element for the selector
 */
export function qsIdStartsWith(selector, scope) {
  return (scope || document).querySelector(`[id^=${selector}]`);
}

/**
 * querySelector wrapper
 *
 * @param {string} selector Selector to query
 * @param {Element} [scope] Optional scope element for the selector
 */
export function qsAllIdStartsWith(selector, scope) {
  return (scope || document).querySelectorAll(`[id^=${selector}]`);
}

/**
 * addEventListener wrapper
 *
 * @param {Element|Window} target Target Element
 * @param {string} type Event name to bind to
 * @param {Function} callback Event callback
 * @param {boolean} [capture] Capture the event
 */
export function onEvent(target, type, callback, capture) {
  target.addEventListener(type, callback, !!capture);
}

/**
 * Hide DOM element by CSS class
 *
 * @param {DOMElement} element DOM element to hide
 */
export function hideElement(element) {
  element.classList.add('hidden');
}

/**
 * Use this helper function to populate a series of classnames in a component
 * It works both with ternary operators and &&.
 * Primarily useful with conditional class logic
 *
 * Example: <Component class={classes('class1', 'class2')}
 * Example: <Component class={classes('class1', condition && 'conditionalClass')}
 * Example: <Component class={classes('class1', condition ? 'conditionalClass' : 'otherClass')}
 *
 * @param _classes Array of strings or varargs.
 * @returns {string} Space separated, filtered string containing class names
 */
export const classes = (..._classes) => _classes.filter(Boolean).join(' ');

/**
 * This function will update the QueryString from a URI to a set value.
 * ex.
 * updateQueryStringParameter("https://storytel.com/test?qParam=44param", "qParam", "33param") = https://storytel.com/test?qParam=33param
 * updateQueryStringParameter("https://storytel.com/test?qParam=44param", "newParam", "new") = https://storytel.com/test?qParam=44param&newParam=new
 * @param uri
 * @param key
 * @param value
 * @returns {string|*}
 */
export function updateQueryStringParameter(uri, key, value) {
  if (!uri) {
    return uri;
  }
  var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
  var separator = uri.indexOf('?') !== -1 ? '&' : '?';
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + '=' + value + '$2');
  } else {
    return uri + separator + key + '=' + value;
  }
}

export function getURLParameter(name) {
  return decodeURI((RegExp(name + '=' + '(.+?)(&|$)').exec(location.search) || ['', null])[1]);
}

export function getFirstParagraph(html) {
  const re = new RegExp('<p>(.*?)</p>', 'g');
  const match = html.match(re);
  if (match && match.length) {
    return match[0];
  }
  return html;
}

export const encodeFormData = (data) => {
  return data
    .map((pair) => encodeURIComponent(pair[0]) + '=' + encodeURIComponent(pair[1]))
    .join('&');
};

export function debounce(handler, timeout) {
  let timer = -1;
  return (v) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      handler(v);
    }, timeout);
  };
}
